import campingTrailer from './camping-trailer.svg'
import fifthWheel from './fifth-wheel.svg'
import travelTrailer from './travel-trailer.svg'
import toyHauler from './toy-hauler.svg'
import truckCamper from './truck-camper.svg'

export const PRODUCT_TYPE_IMAGES = {
  CAMPING_TRAILER: campingTrailer,
  FIFTH_WHEEL: fifthWheel,
  TRAVEL_TRAILER: travelTrailer,
  TOY_HAULER: toyHauler,
  TRUCK_CAMPER: truckCamper,
}
